export interface MediaMaskOption {
  value: string;
  label: string;
  pngMask?: string; // Путь к PNG маске
}

// Статические данные масок
export const MEDIA_MASK_OPTIONS: MediaMaskOption[] = [
  // Basic Masks (числовые маски)
  { value: 'basic-mask-10', label: 'Basic Mask 10', pngMask: '/masks/10.png' },
  { value: 'basic-mask-11', label: 'Basic Mask 11', pngMask: '/masks/11.png' },
  { value: 'basic-mask-12', label: 'Basic Mask 12', pngMask: '/masks/12.png' },
  { value: 'basic-mask-13', label: 'Basic Mask 13', pngMask: '/masks/13.png' },
  { value: 'basic-mask-14', label: 'Basic Mask 14', pngMask: '/masks/14.png' },
  { value: 'basic-mask-15', label: 'Basic Mask 15', pngMask: '/masks/15.png' },
  { value: 'basic-mask-2', label: 'Basic Mask 2', pngMask: '/masks/2.png' },
  { value: 'basic-mask-4', label: 'Basic Mask 4', pngMask: '/masks/4.png' },
  { value: 'basic-mask-5', label: 'Basic Mask 5', pngMask: '/masks/5.png' },
  { value: 'basic-mask-6', label: 'Basic Mask 6', pngMask: '/masks/6.png' },
  { value: 'basic-mask-7', label: 'Basic Mask 7', pngMask: '/masks/7.png' },
  { value: 'basic-mask-8', label: 'Basic Mask 8', pngMask: '/masks/8.png' },
  { value: 'basic-mask-9', label: 'Basic Mask 9', pngMask: '/masks/9.png' },
  
  // Brush Strokes (мазки)
  { value: 'brush-stroke-1', label: 'Brush Stroke 1', pngMask: '/masks/brushstroke1.png' },
  { value: 'brush-stroke-3', label: 'Brush Stroke 3', pngMask: '/masks/brushstroke3.png' },
  
  // Brush Masks (маски-кисти)
  { value: 'brush-mask-1', label: 'Brush Mask 1', pngMask: '/masks/brushmask1.png' },
  { value: 'brush-mask-2', label: 'Brush Mask 2', pngMask: '/masks/brushmask2.png' },
  { value: 'brush-mask-3', label: 'Brush Mask 3', pngMask: '/masks/brushmask3.png' },
  { value: 'brush-mask-4', label: 'Brush Mask 4', pngMask: '/masks/brushmask4.png' },
  { value: 'brush-mask-5', label: 'Brush Mask 5', pngMask: '/masks/brushmask5.png' },
  { value: 'brush-mask-6', label: 'Brush Mask 6', pngMask: '/masks/brushmask6.png' },
  { value: 'brush-mask-7', label: 'Brush Mask 7', pngMask: '/masks/brushmask7.png' },
  { value: 'brush-mask-8', label: 'Brush Mask 8', pngMask: '/masks/brushmask8.png' },
  { value: 'brush-mask-9', label: 'Brush Mask 9', pngMask: '/masks/brushmask9.png' },
  { value: 'brush-mask-10', label: 'Brush Mask 10', pngMask: '/masks/brushmask10.png' },
  
  // Number Masks (цифры)
  { value: 'number-0', label: 'Number 0', pngMask: '/masks/num0.png' },
  { value: 'number-1', label: 'Number 1', pngMask: '/masks/num1.png' },
  { value: 'number-2', label: 'Number 2', pngMask: '/masks/num2.png' },
  { value: 'number-3', label: 'Number 3', pngMask: '/masks/num3.png' },
  { value: 'number-4', label: 'Number 4', pngMask: '/masks/num4.png' },
  { value: 'number-5', label: 'Number 5', pngMask: '/masks/num5.png' },
  { value: 'number-6', label: 'Number 6', pngMask: '/masks/num6.png' },
  { value: 'number-7', label: 'Number 7', pngMask: '/masks/num7.png' },
  { value: 'number-8', label: 'Number 8', pngMask: '/masks/num8.png' },
  { value: 'number-9', label: 'Number 9', pngMask: '/masks/num9.png' },
  
  // Cyrillic Letters (буквы)
  { value: 'cyrillic-a', label: 'Cyrillic А', pngMask: '/masks/А.png' },
  { value: 'cyrillic-b', label: 'Cyrillic Б', pngMask: '/masks/Б.png' },
  { value: 'cyrillic-v', label: 'Cyrillic В', pngMask: '/masks/В.png' },
  { value: 'cyrillic-g', label: 'Cyrillic Г', pngMask: '/masks/Г.png' },
  { value: 'cyrillic-d', label: 'Cyrillic Д', pngMask: '/masks/Д.png' },
  { value: 'cyrillic-e', label: 'Cyrillic Е', pngMask: '/masks/Е.png' },
  { value: 'cyrillic-ye', label: 'Cyrillic Є', pngMask: '/masks/Є.png' },
  { value: 'cyrillic-zh', label: 'Cyrillic Ж', pngMask: '/masks/Ж.png' },
  { value: 'cyrillic-z', label: 'Cyrillic З', pngMask: '/masks/З.png' },
  { value: 'cyrillic-i', label: 'Cyrillic И', pngMask: '/masks/И.png' },
  { value: 'cyrillic-yi', label: 'Cyrillic І', pngMask: '/masks/І.png' },
  { value: 'cyrillic-k', label: 'Cyrillic К', pngMask: '/masks/К.png' },
  { value: 'cyrillic-l', label: 'Cyrillic Л', pngMask: '/masks/Л.png' },
  { value: 'cyrillic-m', label: 'Cyrillic М', pngMask: '/masks/М.png' },
  { value: 'cyrillic-n', label: 'Cyrillic Н', pngMask: '/masks/Н.png' },
  { value: 'cyrillic-o', label: 'Cyrillic О', pngMask: '/masks/О.png' },
  { value: 'cyrillic-p', label: 'Cyrillic П', pngMask: '/masks/П.png' },
  { value: 'cyrillic-r', label: 'Cyrillic Р', pngMask: '/masks/Р.png' },
  { value: 'cyrillic-s', label: 'Cyrillic С', pngMask: '/masks/С.png' },
  { value: 'cyrillic-t', label: 'Cyrillic Т', pngMask: '/masks/Т.png' },
  { value: 'cyrillic-u', label: 'Cyrillic У', pngMask: '/masks/У.png' },
  { value: 'cyrillic-f', label: 'Cyrillic Ф', pngMask: '/masks/ф.png' },
  { value: 'cyrillic-h', label: 'Cyrillic Х', pngMask: '/masks/Х.png' },
  { value: 'cyrillic-ts', label: 'Cyrillic Ц', pngMask: '/masks/Ц.png' },
  { value: 'cyrillic-ch', label: 'Cyrillic Ч', pngMask: '/masks/Ч.png' },
  { value: 'cyrillic-shch', label: 'Cyrillic Щ', pngMask: '/masks/Щ.png' },
  { value: 'cyrillic-soft', label: 'Cyrillic Ь', pngMask: '/masks/ь.png' },
  { value: 'cyrillic-yu', label: 'Cyrillic Ю', pngMask: '/masks/Ю.png' },
  { value: 'cyrillic-ya', label: 'Cyrillic Я', pngMask: '/masks/я.png' }
];

/**
 * Получает PNG маску по значению формы
 * @param shape - значение формы маски
 * @returns путь к PNG файлу маски
 */
export function getMaskPng(shape?: string): string {
  if (!shape) return '/masks/10.png';
  
  const option = MEDIA_MASK_OPTIONS.find(opt => opt.value === shape);
  return option?.pngMask || '/masks/10.png';
}

/**
 * Создает стили CSS маски
 * @param maskShape - форма маски
 * @returns объект со стилями CSS
 */
export function getMaskStyles(maskShape?: string): Record<string, string> {
  if (!maskShape) return {};
  
  const maskPng = getMaskPng(maskShape);
  
  // Если это PNG маска, применяем CSS маску
  if (maskShape && (maskShape.startsWith('basic-mask-') || 
                    maskShape.startsWith('brush-') || 
                    maskShape.startsWith('number-') || 
                    maskShape.startsWith('cyrillic-'))) {
    const styles = {
      maskImage: `url(${maskPng})`,
      maskSize: 'contain',
      maskPosition: 'center',
      maskRepeat: 'no-repeat',
      WebkitMaskImage: `url(${maskPng})`,
      WebkitMaskSize: 'contain',
      WebkitMaskPosition: 'center',
      WebkitMaskRepeat: 'no-repeat'
    };
    return styles;
  }
  
  // Для простых форм возвращаем пустой объект
  return {};
}

/**
 * Получает все доступные опции масок
 * @returns массив опций масок
 */
export function getMediaMaskOptions(): MediaMaskOption[] {
  return MEDIA_MASK_OPTIONS;
}

/**
 * Проверяет, является ли форма PNG маской
 * @param shape - форма для проверки
 * @returns true если это PNG маска
 */
export function isPngMask(shape?: string): boolean {
  if (!shape) return false;
  return shape.startsWith('basic-mask-') || 
         shape.startsWith('brush-') || 
         shape.startsWith('number-') || 
         shape.startsWith('cyrillic-');
}
